module.exports = __webpack_public_path__ + "static/media/Introduction_to_IoT.c0bee9f0.jpg";